(ns app.domain.application.guards.inspection
  (:require [app.domain.application.guards.utils :as guard-utils]
            [app.domain.fee.model :as fee-model]
            [app.domain.group.model :as group-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [core.db.entity.util :as eu]
            [core.util.util :as util]
            [tilakone.core :as tk]))

(def no-open-orders?
  {:name    :process.guard/no-open-orders?
   :type    :guard
   :handler (fn [fsm]
              (->> fsm
                   :request
                   :target
                   :entity/_parent
                   (filter (eu/is-type-fn :entity.type/inspection-order))
                   (every? (du/in-state-fn :inspection.order.state/cleared
                                           :inspection.order.state/removed))))})


(defn- no-inspection-role-restriction?
  "If role restriction is enabled user must be inspector, manager or super admin."
  [{user             :core.user/user
    {:keys [target]} :request        :as fsm}]
  (or (-> fsm
          (guard-utils/group-feature-available? :group.feature/inspection-restriction-role)
          not)
      (group-model/any-required-authority-role?
        (group-model/get-authority-group target)
        user
        #{:group.role/inspector :group.role/manager})
      (guard-utils/user-is-admin? user)))


(def inspector-meets-role-requirements?
  {:name    :process.guard/inspector-meets-role-requirements?
   :type    :guard
   :handler no-inspection-role-restriction?})

(def inspector-is-qualified?
  {:name    :process.guard/inspector-is-qualified?
   :type    :guard
   :handler (fn [{user                                            :core.user/user
                  {:keys [target]}                                :request
                  [_ {:keys [inspection-id visit-id booking-id]}] ::tk/signal}]
              (let [inspection (if inspection-id
                                 (du/find-descendant {:db/id inspection-id} target) ;; start visit
                                 (->> target (du/find-descendant {:db/id visit-id}) :entity/parent))] ;; end visit
                (inspection-model/no-inspection-qualification-restriction?
                  (util/mmap user
                             target
                             inspection
                             booking-id))))})

(def outstanding-bills-paid-or-override?
  {:name    :process.guard/outstanding-bills-paid-or-override?
   :type    :guard
   :handler (fn [{:keys                                    [request]
                  [_ {:keys [override-outstanding-bill?]}] ::tk/signal
                  :as                                      fsm}]
              (let [{:keys [feature-flags]} request
                    visit                   (guard-utils/find-child-entity fsm :visit-id)
                    inspection              (:entity/parent visit)
                    result                  (:inspection.visit/visit-result visit)
                    feature-on?             (contains? feature-flags :feature-flag.id/outstanding-bill-close-inspection)
                    requires-pay?           (inspection-model/visit-result-requires-bill-payment? result)
                    closes?                 (inspection-model/visit-result-rule-set? result :inspection.visit.result-rule/close-inspection)
                    has-bills?              (some fee-model/confirmed-bill? (-> inspection :entity/parent fee-model/phase-bills))]
                (or (not feature-on?)
                    (not requires-pay?)
                    (not closes?)
                    (not has-bills?)
                    override-outstanding-bill?)))})

(def guards
  [no-open-orders?
   inspector-meets-role-requirements?
   inspector-is-qualified?
   outstanding-bills-paid-or-override?])
